<template>
  <el-table-column
    prop="location.value"
    label="Terület"
    show-overflow-tooltip
    min-width="110"
    sortable="custom"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.location_id">{{ scope.row.location.value }}</span>
      <el-tag type="danger" v-else size="small">Nincs terület</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.valie',
  };
</script>
